import { csx } from '@vtex/admin-ui'

export const styles = {
  container: csx({
    marginTop: '-3px',
    zIndex: -1,
  }),
}
